import { createFileRoute } from "@tanstack/react-router";
import { BabylonSceneWrapper } from "@/babylon/components/BabylonSceneWrapper";
import { DebouncedStrategy } from "@/pages/3d/memory/DebouncedStrategy";

export const Route = createFileRoute("/demo/3d/memory/debounced")({
  component: () => (
    <BabylonSceneWrapper>
      <DebouncedStrategy />
    </BabylonSceneWrapper>
  ),
});
